import {MoreHorizontal} from 'lucide-react';
import {Button} from '@/shadcn_components/ui/button';
import useDialogState from '@/hooks/useDialogState';
import {useContext} from 'react';
import {ConversationContext} from './types';
import clsx from 'clsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shadcn_components/ui/dropdown-menu';
import {DeleteConfirmDialog} from '@/components/refinedev/dialogs/delete-confirm-dialog';
import {CreateConversationButton} from './components/create-conversation-dialog';
import {EditConversationDialog} from './components/edit-conversation-dialog';
import {UserIconList} from '@/pages/_shared/user-icon-list';

interface SidebarProps {
  onClick?: () => void;
  isMobile: boolean;
}

export function Sidebar({isMobile}: SidebarProps) {
  const {conversations, activeConversation, setActiveConversation} =
    useContext(ConversationContext);

  function conversationClick(conversation) {
    console.log('conversation', conversation);
    setActiveConversation?.(conversation);
  }

  const deleteConfirmDialog = useDialogState();
  const editConversationDialog = useDialogState();

  return (
    <div className="relative group flex flex-col h-full bg-muted/10 dark:bg-muted/20 gap-4 p-2">
      <div className="flex justify-between p-2 items-center">
        <div className="flex gap-2 items-center text-xl">
          <p className="font-semibold">Trao đổi</p>
          <span className="text-zinc-500">({conversations?.length || 0})</span>
        </div>

        <div>
          <CreateConversationButton />
        </div>
      </div>
      <nav className="grid gap-1 px-2 overflow-y-auto">
        {(conversations || []).map((conversation, index) => (
          <div
            key={index}
            className={clsx(
              'group/conversation mb-2 cursor-pointer hover:bg-green-100 p-2 rounded-md flex justify-between items-center',
              {
                'bg-green-200': activeConversation?.id === conversation.id,
              },
            )}
            onClick={() => conversationClick(conversation)}>
            <div className="flex items-center gap-2">
              <div className="flex-grow">
                <div className="font-semibold">{conversation.name}</div>
                <div className="text-sm text-gray-500">{conversation.description}</div>                
              </div>              
            </div>
            <DropdownMenu modal={false}>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="opacity-0 group-hover/conversation:opacity-100 transition-opacity duration-300">
                  <MoreHorizontal className="w-4 h-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuItem
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    editConversationDialog.openDialog({
                      id: conversation.id,
                    });
                  }}>
                  Chỉnh sửa
                </DropdownMenuItem>
                <DropdownMenuItem
                  className="text-destructive"
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    deleteConfirmDialog.openDialog({
                      resource: 'conversations',
                      id: conversation.id,
                    });
                  }}>
                  Xóa
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        ))}
      </nav>
      <DeleteConfirmDialog dialogState={deleteConfirmDialog} />
      <EditConversationDialog dialogState={editConversationDialog} />
    </div>
  );
}
